/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc
 */
import * as References from './CroAgentLandingPageBrandingOptimizationsRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc#submit
 */
export const SUBMIT_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_CroAgentLandingPageBrandingOptimizationsRpc_submit';
export const SUBMIT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SUBMIT_QUERY_FIELD_NAME,
  args: ['pageId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.submitRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc#fetchForPortal
 */
export const FETCH_FOR_PORTAL_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_CroAgentLandingPageBrandingOptimizationsRpc_fetchForPortal';
export const FETCH_FOR_PORTAL_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_FOR_PORTAL_QUERY_FIELD_NAME,
  args: [],
  fetcher(_, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.fetchForPortalRpc, {
      timeout: ctx.timeout
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc#dismiss
 */
export const DISMISS_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_CroAgentLandingPageBrandingOptimizationsRpc_dismiss';
export const DISMISS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: DISMISS_QUERY_FIELD_NAME,
  args: ['optimizationId'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.dismissRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc#save
 */
export const SAVE_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_CroAgentLandingPageBrandingOptimizationsRpc_save';
export const SAVE_QUERY = /* #__PURE__ */registerQuery({
  fieldName: SAVE_QUERY_FIELD_NAME,
  args: ['optimizationId'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.saveRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.page.content.generator.rpc.CroAgentLandingPageBrandingOptimizationsRpc#fetchBySuggestionId
 */
export const FETCH_BY_SUGGESTION_ID_QUERY_FIELD_NAME = 'com_hubspot_page_content_generator_rpc_CroAgentLandingPageBrandingOptimizationsRpc_fetchBySuggestionId';
export const FETCH_BY_SUGGESTION_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: FETCH_BY_SUGGESTION_ID_QUERY_FIELD_NAME,
  args: ['suggestionId'],
  fetcher(request, ctx) {
    var _ctx$customClient5;
    return ((_ctx$customClient5 = ctx.customClient) !== null && _ctx$customClient5 !== void 0 ? _ctx$customClient5 : chirpClient).call(References.fetchBySuggestionIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});